import { USER_ADD_BODY_STYLE_FILTER, USER_REMOVE_BODY_STYLE_FILTER } from '../constants';

const initialState = {
  filter: ['all']
};

// TODO: Too much logic in here, look at moving parts out to functions?
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case USER_ADD_BODY_STYLE_FILTER: {
      if (action.bodyStyle === 'all') {
        return {
          ...initialState
        };
      }

      if (state.filter.indexOf(action.bodyStyle) === -1) {
        // Remove all, if present
        const existsIndex = state.filter.indexOf('all');

        if (existsIndex > -1) {
          return {
            ...state,
            filter: [
              ...state.filter.slice(0, existsIndex),
              ...state.filter.slice(existsIndex + 1),
              action.bodyStyle
            ]
          }
        }

        return {
          ...state,
          filter: [
            ...state.filter,
            action.bodyStyle
          ]
        };
      }

      return {
        ...state,
      };
    }
    case USER_REMOVE_BODY_STYLE_FILTER: {
      const existsIndex = state.filter.indexOf(action.bodyStyle);

      if (existsIndex > -1) {
        if (state.filter.length === 1) {
          return {
            ...initialState
          }
        }

        return {
          ...state,
          filter: [
            ...state.filter.slice(0, existsIndex),
            ...state.filter.slice(existsIndex + 1)
          ]
        };
      }

      return state;
    }
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/bodyStyleFilter.js
 **/